<template>
  <b-modal
    :id="id"
    ref="modalReview"
    class="modalReview modal-md">
    <div
      slot="modal-header"
      :header-border-variant="0"
      class="modalReviewHeader">
      <svgicon
        name="close"
        width="14"
        height="14"
        class="closeModal"
        @click="$refs['modalReview'].hide()"/>
      Добавление отзыва
    </div>
    <div class="content">
      <div class="row">
        <div class="col">
          <label for="service">Услуга</label>
          <b-input
            id="service"
            v-model="service"
            type="text"/>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <label for="text">Текст отзыва</label>
              <textarea
                id="text"
                v-model="text"
                class="textarea"/>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="text-danger m-0">
                Внимание!
              </p>
              <label
                class="m-0">Измените текст импортируемого отзыва, чтобы он отличался от
                оригинала</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <label for="service">Ник автора</label>
          <b-input
            id="author"
            v-model="author"
            type="text"/>
        </div>
        <div class="col price-col">
          <label for="service">Цена</label>
          <div class="price-currency">
            <b-input
              id="price"
              v-model="price"
              type="number"
              class="price-input"/>
            <div class="currency">
              Руб.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label for="game">Источник</label>
          <b-form-select
            v-model="source"
            :disabled="!reviewsSources"
            class="selectGroup">
            <template v-for="(reviewsSource, index) in reviewsSources">
              <option
                :key="index"
                :value="reviewsSource.id">
                {{ reviewsSource.name }}
              </option>
            </template>
          </b-form-select>
        </div>
        <div class="col">
          <label for="game">Игра</label>
          <v-select
            ref="gameSelect"
            v-model="selectGame"
            height="40"
            :disabled="games == ''"
            class="select-group games-select"
            label="name"
            :options="games"
            placeholder="Поиск по игре">
            <template v-slot:option="option">
              <img
                v-if="option.icon != null"
                height="32"
                width="32"
                :src="
                  backendUrl +
                    '/img/game/' +
                    option.icon +
                    '?v=' +
                    option.updated_at
                "
                @error.self="replaceGameIconByDefault">
              <img
                v-else
                width="32"
                height="32"
                :src="'/img/game-no-icon.png'">
              {{ option.name }}
            </template>
          </v-select>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label for="date">Дата</label>

          <VueCtkDateTimePicker
            id="date"
            ref="VueCtkDateTimePicker"
            v-model="date"
            position="relative"
            :label="'Выберите дату'"
            :format="'DD.MM.YYYY hh:mm a'"
            :formatted="'DD.MM.YYYY hh:mm'"/>
        </div>
        <div class="col rating-col">
          <label for="rating">Оценка</label>
          <ratingStars
            id="rating"
            :key="rating + '-rating-stars'"
            :rating="rating"
            :change-rating="changeRating"/>
        </div>
      </div>
    </div>
    <div
      slot="modal-footer"
      class="modalReviewFooter">
      <button
        class="btn btn-success"
        :disabled="
          !text ||
            !service ||
            !author ||
            !price ||
            !source ||
            !selectGame ||
            !date ||
            (text instanceof String && text.trim().length == 0) ||
            (service instanceof String && service.trim().length == 0) ||
            (author instanceof String && author.trim().length == 0) ||
            (price instanceof String && price.trim().length == 0) ||
            (source instanceof String &&
            source.trim().length == 0 && !selectGame.id) ||
            (date instanceof String && date.trim().length == 0)
        "
        @click="submitReview">
        Оставить отзыв
      </button>
    </div>
  </b-modal>
</template>

<script>
import Vue from "vue";
import { getDate, getPhoto } from "~/services/base";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { errorResponse } from "~/services/errors-template";
import "~/icons/close";
import ratingStars from "~/components/base/ratingStars.vue";
import axios from "axios/index";
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
export default {
  components: {
    ratingStars
  },
  props: {
    id: {
      type: String,
      default: "ModalReview"
    },
    external: {
      type: Object,
      default: null
    },
    userId: {
      type: Number,
      default: null
    },
    reviews: {
      type: Object,
      default: null
    },
    updateEntity: {
      type: Boolean,
      default: false
    },
    games: {
      type: Array,
      default: null
    },
    reviewsSources: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      text: "",
      service: "",
      author: "",
      price: "",
      source: "",
      selectGame: "",
      date: "",
      rating: 1,
      backendUrl: process.env.backendUrl
    };
  },
  mounted: function() {
    if (this.external) {
      this.text = this.external.text;
      this.rating = parseInt(this.external.rating);
      this.source = this.external.external.source;
      this.author = this.external.external.author_name;
      this.price = this.external.external.price;
      this.service = this.external.external.service;
      this.date = this.external.external.created_at;
      this.selectGame = this.games ? this.games.filter(item=>item.id == this.external.external.game_id)[0] : null;
    }
    if (!this.userId) {
      this.userId = this.$route.params.id;
    }
  },
  methods: {
    changeRating: function(rating) {
      this.rating = parseInt(rating);
    },
    submitReview: async function() {
      let reviews = [];
      let timestamp =
        Date.parse(this.$refs.VueCtkDateTimePicker.dateTime) / 1000;
      let newReview = {
        service: this.service,
        game_id: parseInt(this.selectGame.id),
        author_name: this.author,
        source: this.source,
        created_at: timestamp,
        price: this.price,
        rating: this.rating,
        text: this.text,
        type: 2,
        id: this.external ? parseInt(this.external.id) : null
      };
      reviews.push(newReview);

      let vuexData = { userId: this.userId, reviews: reviews };

      await this.$store
        .dispatch("reviews/ADD_EXTERNAL_REVIEW", vuexData)
        .then(async response => {
          0;
          if (!response.success) {
            if (response.data) {
              if (Array.isArray(response.data)) {
                response.data.forEach(element => {
                  this.$noty.error(element.message);
                });
              } else {
                this.$noty.error(response.data.message);
              }
            }
          } else {
            var newData = { userId: this.userId, query: this.$route.query };
            this.$noty.success("Отзыв сохранен");
            if (!this.external) {
              this.service = "";
              this.author = "";
              this.source = "";
              this.price = "0";
              this.text = "";
              this.rating = 1;
            }
          }
        })
        .catch(exception => {
          this.$noty.error("Не удалось сохранить отзыв.");
        });

        this.$emit('callback');
    }
  }
};
</script>
<style lang="scss" scoped>
.modalReviewHeader {
  font-size: 20px;
}
.content {
  padding: 17px 32px 0;
}
.description {
  position: relative;
  display: block;
  margin-bottom: 20px;
  padding-left: 71px;
  font-size: 16px;
  line-height: 50px;
  font-weight: 500;
  max-width: 465px;
  &:before {
    position: absolute;
    left: 0;
    content: "";
    width: 51px;
    height: 50px;
    background: url("data:image/svg+xml;base64,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");
  }
}
.textarea {
  width: 100%;
  height: 161px;
  padding: 10px 14px;
  border: 1px solid #dadada;
  border-radius: 4px;
  color: #6e7279;
  resize: none;
}
.modalReviewFooter {
  display: flex;
  width: 100%;
  padding: 15px 32px 20px;
  align-items: center;
  justify-content: flex-start;
  .btn {
    margin-right: 16px;
    width: 160px;
    font-weight: 500;
  }
}
.content label {
  margin-bottom: 0;
  margin-top: 0.5rem;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #6e7279;
}
.content .rating-stars {
  justify-content: flex-start;
}

.content .rating-col {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content .price-col {
  display: flex;
  flex-direction: column;
}

.content .price-currency {
  display: flex;
  border: 1px solid #dadada;
  border-radius: 4px;
  max-height: 40px;
}
.content .price-input {
  border: none;
  height: 100%;
}
.content .price-currency .currency {
  display: flex;
  align-items: center;
  border-left: 1px solid #dadada;
  padding: 10px 31px 10px 17px;
  color: #6e7279;
}
</style>
